import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import {
  fetchGapCasinoLaunchUrl,
  fetchQtechLaunchUrl,
} from "../../store/slices/casinoSlice";

const LaunchGame = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [launchUrl, setLaunchUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search);
      const useQtech = params.get("useQtech") === "true";
      const gameId = (params.get("gameId") || params.get("gameCode") || "").trim();
      const category = (params.get("category") || "Game Lobby").trim();

      if (!gameId) {
        navigate("/casino", { replace: true });
        return;
      }

      try {
        let result;
        if (useQtech) {
          const providerShortName = (params.get("providerShortName") || "").trim();
          if (!providerShortName) {
            navigate("/casino", { replace: true });
            return;
          }
          result = await dispatch(
            fetchQtechLaunchUrl({
              providerCode: providerShortName,
              gameId,
            }),
          ).unwrap();
        } else {
          const providerName = (params.get("provider") || "MAC88").trim();
          result = await dispatch(
            fetchGapCasinoLaunchUrl({
              category,
              gameId,
              providerName,
            }),
          ).unwrap();
        }

        const url = result?.launchUrl || "";
        if (!url) {
          navigate("/casino", { replace: true });
          return;
        }
        setLaunchUrl(url);
      } catch {
        navigate("/casino", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [dispatch, navigate, location.search]);

  return (
    <>
      {loading ? (
        <div className="w-full py-10 text-center font-semibold">Loading game...</div>
      ) : (
        <iframe
          src={launchUrl}
          title="Casino game"
          allowFullScreen
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
          className="game-iframe"
        />
      )}
    </>
  );
};

export default LaunchGame;
